// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2WhRq","aqi-widget":"_1z6Lf","send-us-your-videosarticles":"_1Qf4W"};